define.alias("shared/utils/array-filters/get-first-point-by-name", "media/utils/array-filters/get-first-point-by-name");